import React from "react";
import Banner from "../../Components/userComponents/Common/Banner";
import AllArticles from "../../Components/userComponents/ArticlesComponents/AllArticles";

const Articles = () => {
  return (
    <div>
      <Banner page="Articles" path="articles" />
      <AllArticles />
    </div>
  );
};

export default Articles;
